import ContainerWithTabs from "Components/Admin/ContainerWithTabs";

import CreateAdmin from "./Components/Admin";

const CreateUser = () => {
  return (
    <ContainerWithTabs
      mt="0px"
      fitContent
      tabs={[
        {
          title: "Administrador",
          component: <CreateAdmin />,
        },
      ]}
    />
  );
};

export default CreateUser;
